import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { MessageBlockComponent } from "@hermes/aphrodite/message-block";
import { SeparatorComponent } from "@hermes/aphrodite/separator";

import { ShippingDelayMessageComponent } from "./shipping-delay-message.component";

@NgModule({
    imports: [CommonModule, SeparatorComponent, MessageBlockComponent],
    declarations: [ShippingDelayMessageComponent],
    exports: [ShippingDelayMessageComponent],
})
export class ShippingDelayMessageModule {}
